<template>
  <div>
    <h3 class="settings__section-title delete-account__header">
      Delete Account
    </h3>
    <p class="settings__section-subtitle">
      Your account and your data will be permanently deleted. You can downgrade
      to a free plan instead to keep it.
    </p>
    <button class="delete-account__btn btns btns--red" @click="showPopup">
      Delete your account
    </button>
    <DeleteAccountPopup ref="popupCancel" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import DeleteAccountPopup from '@/app/components/billing/DeleteAccountPopup.vue'

const popupCancel = ref<InstanceType<typeof DeleteAccountPopup> | null>(null)

function showPopup(): void {
  if (!popupCancel.value) {
    return
  }

  popupCancel.value.show()
}
</script>

<style lang="scss" scoped>
p {
  max-width: 600px;
}

.delete-account__header {
  margin-top: 24px;
}
</style>
